<app-dfp-panel title="Documentos de origem" [collapsible]="true">
  <div panelActions class="source-documents__filters ignore-export">
    <button
      type="button"
      class="source-documents__chip"
      [class.source-documents__chip--active]="kindFilter === null"
      (click)="setKindFilter(null)">
      Todos
      <span class="source-documents__chip-count">{{ totalFor(null) }}</span>
    </button>

    @for (kind of kindOrder; track kind) {
      @if (hasKind(kind)) {
        <button
          type="button"
          class="source-documents__chip"
          [class.source-documents__chip--active]="kindFilter === kind"
          (click)="setKindFilter(kind)">
          {{ kindLabels[kind] }}
          <span class="source-documents__chip-count">{{ totalFor(kind) }}</span>
        </button>
      }
    }
  </div>

  <div class="source-documents" [class.source-documents--single]="!canSeeNotUsed">
    <section class="source-documents__column">
      <header class="source-documents__column-head">
        <span class="source-documents__section-label">Em uso nesta tela</span>
        <span class="source-documents__badge">{{ inUse.length }}</span>
        <app-dfp-precedence-info />
      </header>

      <div class="source-documents__list">
        @for (document of inUse; track document.id) {
          <div class="source-documents__row">
            <i class="source-documents__icon" [class]="kindIcons[document.kind]"></i>
            <div class="source-documents__info">
              <!--
                Sem `ignore-export` aqui, ao contrário dos chips e do botão de download: o nome É o
                conteúdo da linha, e marcá-lo apagaria o documento do PDF/XLSX exportado — mesma
                armadilha já documentada para o rótulo de ano em `year-column-menu`.
              -->
              @if (canPreview(document)) {
                <button
                  type="button"
                  class="source-documents__name source-documents__name--link"
                  [title]="previewHint(document)"
                  (click)="openPreview(document)">
                  {{ displayName(document) }}
                </button>
              } @else {
                <div class="source-documents__name" [title]="previewHint(document)">
                  {{ displayName(document) }}
                </div>
              }
              <div class="source-documents__meta">
                {{ kindLabels[document.kind] }} · {{ coverageLabel(document) }} · enviado em
                {{ document.uploadDate | date: 'dd/MM/yyyy' }}
                @if (uploaderName(document)) {
                  por {{ uploaderName(document) }}
                }
              </div>
              @if (document.audit?.status || usageReason(document)) {
                <div class="source-documents__selection" data-testid="source-selection">
                  <app-audit-seal [audit]="document.audit" [compact]="true" />
                  @if (usageReason(document); as reason) {
                    <span class="source-documents__reason">{{ reason }}</span>
                  }
                </div>
              }
            </div>
            @if (document.downloadLink) {
              <a
                class="source-documents__download ignore-export"
                [href]="document.downloadLink"
                target="_blank"
                rel="noopener"
                [attr.aria-label]="'Baixar ' + displayName(document)">
                <i class="pi pi-download"></i>
              </a>
            }
            @if (canRemove(document)) {
              <app-button
                class="source-documents__remove ignore-export"
                icon="pi pi-trash"
                [pureIcon]="true"
                severity="danger"
                [title]="'Remover ' + displayName(document) + ' e os valores que ele alimenta'"
                (sendButtonClick)="requestRemove(document)" />
            }
          </div>
        } @empty {
          <div class="source-documents__hint">{{ emptyLabel('inUse') }}</div>
        }
      </div>
    </section>

    <!--
      Coluna restrita a ADMIN e TENANT. O gate é o PAYLOAD (`notUsed === null`), não uma checagem de role
      aqui — quem corta é o backend, ver `canSeeNotUsed`. `@if` e não CSS: esconder por estilo deixaria os
      nomes de arquivo e os links de download no DOM.
    -->
    @if (canSeeNotUsed) {
      <section class="source-documents__column source-documents__column--muted">
        <header class="source-documents__column-head">
          <span class="source-documents__section-label">Não utilizados</span>
          <span class="source-documents__badge">{{ notUsed.length }}</span>
        </header>

        <div class="source-documents__list">
          @for (document of notUsed; track document.id) {
            <div class="source-documents__row">
              <i class="source-documents__icon" [class]="kindIcons[document.kind]"></i>
              <div class="source-documents__info">
                <!--
                Sem `ignore-export` aqui, ao contrário dos chips e do botão de download: o nome É o
                conteúdo da linha, e marcá-lo apagaria o documento do PDF/XLSX exportado — mesma
                armadilha já documentada para o rótulo de ano em `year-column-menu`.
              -->
                @if (canPreview(document)) {
                  <button
                    type="button"
                    class="source-documents__name source-documents__name--link"
                    [title]="previewHint(document)"
                    (click)="openPreview(document)">
                    {{ displayName(document) }}
                  </button>
                } @else {
                  <div class="source-documents__name" [title]="previewHint(document)">
                    {{ displayName(document) }}
                  </div>
                }
                <!--
                A data entra aqui porque o título passou a ser derivado: sem ela, dois registros
                sintéticos do mesmo tipo e mesmo motivo ficariam com a linha inteira idêntica, e o
                usuário não teria como saber que são envios diferentes.
              -->
                <!--
                  Com o motivo da regra de precedência ("Substituído pelo documento auditado enviado em 12/03"),
                  ele vai para a linha de baixo, que quebra; a linha de meta é de uma linha só, com reticências,
                  e cortaria justamente a explicação. Sem ele, o motivo genérico do `reason` fica na meta, como antes.
                -->
                <div class="source-documents__meta">
                  {{ kindLabels[document.kind] }} ·
                  @if (!replacedReason(document) && reasonLabel(document)) {
                    {{ reasonLabel(document) }} ·
                  }
                  {{ document.uploadDate | date: 'dd/MM/yyyy' }}
                </div>
                @if (document.audit?.status || replacedReason(document)) {
                  <div class="source-documents__selection" data-testid="source-replacement">
                    <app-audit-seal [audit]="document.audit" [compact]="true" />
                    @if (replacedReason(document); as reason) {
                      <span class="source-documents__reason">{{ reason }}</span>
                    }
                  </div>
                }
              </div>
              @if (document.downloadLink) {
                <a
                  class="source-documents__download ignore-export"
                  [href]="document.downloadLink"
                  target="_blank"
                  rel="noopener"
                  [attr.aria-label]="'Baixar ' + displayName(document)">
                  <i class="pi pi-download"></i>
                </a>
              }
              @if (canRemove(document)) {
                <app-button
                  class="source-documents__remove ignore-export"
                  icon="pi pi-trash"
                  [pureIcon]="true"
                  severity="danger"
                  [title]="'Remover ' + displayName(document) + ' e os valores que ele alimenta'"
                  (sendButtonClick)="requestRemove(document)" />
              }
            </div>
          } @empty {
            <div class="source-documents__hint">{{ emptyLabel('notUsed') }}</div>
          }
        </div>
      </section>
    }
  </div>
</app-dfp-panel>
